import React, { useState, useEffect } from "react";
import { BsTwitter, BsInstagram, BsGithub } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";
import { SiFiverr, SiUpwork } from "react-icons/si";
import useSanity from "../customHooks/useSanity";
const SocialMedia = () => {
	const {socialLinks} = useSanity()
	
	const Social = [
		{
			id: 0,
			icon: <SiFiverr />,
			url : socialLinks.fiverr ? socialLinks.fiverr : "https://fiverr.com"
		},
		{
			id: 1,
			icon: <SiUpwork />,
			url: socialLinks.upwork ? socialLinks.upwork : "https://upwork.com",
		},
		{
			id: 2,
			icon: <BsGithub />,
			url: socialLinks.github ? socialLinks.github : "https://github.com",
		},
		{
			id: 3,
			icon: <BsTwitter />,
			url: socialLinks.twitter
				? socialLinks.twitter
				: "https://twitter.com",
		},
		{
			id: 4,
			icon: <FaFacebookF />,
			url: socialLinks.facebook
				? socialLinks.facebook
				: "https://facebook.com",
		},
		{
			id: 5,
			icon: <BsInstagram />,
			url: socialLinks.instagram
				? socialLinks.instagram
				: "https://instagram.com",
		},
	];
	return (
		<div className="app__social">
			{Social.map((link) => {
				return (
					<a
						href={link.url}
						key={link.id}
						target="_blank"
						rel="noreferrer"
					>
						{link.icon}
					</a>
				);
			})}
		</div>
	);
};

export default SocialMedia;
